var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"comp-ctn-docs row"},[_vm._l((_vm.documents),function(doc,key){return _c('tile-doc',{key:key,attrs:{"doc":doc}})}),_vm._v(" "),(_vm.documents.length === 0)?_c('div',{staticClass:"no-data"},[_vm._v("\n\t\t\tPas encore de documents à votre disposition\n\t\t")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9a4243a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyDocuments/PatrimonialEstate.vue
// module id = null
// module chunks = 